<div class="separator {{ type }}">
	<div class="separator__divider" aria-hidden="true"></div>
	<span>{{ label }}</span>
	<div class="separator__divider" aria-hidden="true"></div>
</div>
